import { render, staticRenderFns } from "./AdSpot.vue?vue&type=template&id=7d6c756e&scoped=true"
import script from "./AdSpot.vue?vue&type=script&lang=js"
export * from "./AdSpot.vue?vue&type=script&lang=js"
import style0 from "./AdSpot.vue?vue&type=style&index=0&id=7d6c756e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6c756e",
  null
  
)

export default component.exports